var React = require('react');

function Plane18 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"plane 18"),React.createElement("g",{"className":"nc-icon-wrapper","strokeWidth":"1","fill":"#000000","stroke":"#000000","key":1},[React.createElement("path",{"fill":"none","stroke":"#000000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"M13.5,5.5h-10l-1-2 h-2l2,6h5l-3,5h4l3-5h2c1.105,0,2-0.895,2-2C15.5,6.395,14.605,5.5,13.5,5.5z","data-cap":"butt","key":0}),React.createElement("polyline",{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"9.5,3.5 8.5,1.5 5.5,1.5 6.5,3.5 ","data-cap":"butt","data-color":"color-2","key":1})])]);
}

Plane18.defaultProps = {"viewBox":"0 0 16 16","width":"16","height":"16"};

module.exports = Plane18;

Plane18.default = Plane18;
